import { useEffect, useState } from 'react';

export const useLazyRoutes = () => {
  const [lazyRoutes, setLazyRoutes] = useState([]);

  useEffect(() => {
    (async () => {
      const { lazyRoutes: routes } = await import('./lazyRoutes');
      setLazyRoutes(routes);
    })();
  }, []);

  return lazyRoutes;
};
